export const sectionData = (report, name) =>
  report?.sections?.[name]?.status === 'ready'
    ? report.sections[name].data
    : null;
export function loadInsights(run, params, timeoutMs = 20000) {
  let timer;
  return Promise.race([
    Promise.resolve().then(() => run('getCreatorInsights', params)),
    new Promise((_, reject) => {
      timer = setTimeout(
        () => reject(new Error('Insights request timed out.')),
        timeoutMs
      );
    }),
  ]).finally(() => clearTimeout(timer));
}
export const reportDate = (value) =>
  value ? new Date(value).toLocaleString() : 'Not loaded';
export const insightLabels = {
  active: 'Published',
  draft: 'Drafts',
  paused: 'Paused',
  expired: 'Ended',
  archived: 'Archived',
  public: 'Everyone',
  private: 'Only me',
  followers: 'Followers & subscribers',
  'named-users': 'Selected recipients',
  group: 'Groups',
  channel: 'Channels',
  topic: 'Topics',
  qr: 'LifeCodes',
  ble: 'Nearby devices',
  nfc: 'LifeTaps',
  'geo-point': 'Locations',
  'geo-fence': 'Location areas',
  spatial: 'Spatial',
  audio: 'Recognized audio',
  url: 'Web links',
  connector: 'Connected services',
  accepted: 'Accepted by provider',
  partial: 'Partially accepted',
  scheduled: 'Scheduled',
  sending: 'Sending',
  delivery_uncertain: 'Needs review',
  not_sent: 'Not sent',
  cancelled: 'Cancelled',
};
export function insightCsv(report) {
  const rows = [
    ['Section', 'Metric', 'Value', 'Updated'],
    ...Object.entries(report.sections).flatMap(([name, section]) => {
      if (section.status !== 'ready')
        return [[name, 'Status', 'Unavailable', report.generatedAt]];
      const metrics = Object.entries(section.data || {})
        .filter(([, value]) => typeof value === 'number')
        .map(([key, value]) => [name, key, value, report.generatedAt]);
      ['states', 'audiences', 'reactions', 'interactions'].forEach((group) => {
        Object.entries(section.data?.[group] || {}).forEach(([key, value]) => {
          if (typeof value === 'number')
            metrics.push([name, `${group}.${key}`, value, report.generatedAt]);
        });
      });
      if (name === 'discovery' && section.data?.suppressed)
        metrics.push([
          name,
          'Events',
          'Not shown (privacy protected)',
          report.generatedAt,
        ]);
      return metrics;
    }),
  ];
  return rows
    .map((row) =>
      row
        .map((value) => {
          const text = String(value ?? '');
          const safe =
            typeof value === 'string' && /^[=+@\-\t\r]/.test(text)
              ? `'${text}`
              : text;
          return `"${safe.replace(/"/g, '""')}"`;
        })
        .join(',')
    )
    .join('\r\n');
}
